<template>
  <div class="zhanwei4"></div>
  <div class="role-container">
    <div class="role-list">
      <div class="role-card" v-for="(item, index) in roles" :key="index">
        <div class="role-card-header">
          <p class="role-name">{{ item.roleName }}</p>
        </div>
        <div class="role-card-media">
          <el-image :src="item.roleImg" fit="cover" class="role-image" />
        </div>
        <div class="role-card-footer">
          <el-button
            type="primary"
            plain
            size="default"
            @click="
              editRole(index);
              isUpdate = true;
            "
            >编辑</el-button
          >
          <el-popconfirm title="确认删除该角色吗?" @confirm="deleteRole(index)">
            <template #reference>
              <el-button type="danger" plain size="default">删除</el-button>
            </template>
          </el-popconfirm>
        </div>
      </div>

      <div
        class="role-card add-role-trigger"
        @click="
          customDraggingVisible = true;
          form = {};
          isUpdate = false;
          fileList = [];
        "
      >
        <div class="add-icon-wrapper">
          <img src="../../image/add.svg" alt="add" />
          <p>添加角色</p>
        </div>
      </div>
    </div>
  </div>

  <el-dialog
    v-model="customDraggingVisible"
    class="custom-dragging-style"
    :title="isUpdate ? '编辑角色' : '建立角色'"
    width="950px"
    draggable
    destroy-on-close
    :close-on-click-modal="false"
  >
    <div class="role_add">
      <div class="role_add_left">
        <div class="upload-section">
          <span class="section-title">角色图片</span>
          <div class="uploader-wrapper">
            <el-upload
              v-model:file-list="fileList"
              :action="UpdateApi"
              list-type="picture-card"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
              :limit="1"
            >
              <el-icon><Plus /></el-icon>
            </el-upload>
            <div class="upload-tip">
              支持 JPG/PNG/GIF 格式<br />建议尺寸 1080*1920px (小于 5MB)
            </div>
          </div>
        </div>

        <div class="form-section">
          <el-form
            :model="form"
            label-width="auto"
            label-position="top"
            class="clean-form"
          >
            <div class="form-row">
              <el-form-item label="角色名称">
                <el-input
                  v-model="form.name"
                  placeholder="请输入角色名称"
                  maxlength="20"
                />
              </el-form-item>
              <el-form-item label="性别">
                <el-input
                  v-model="form.sex"
                  placeholder="请输入性别"
                  maxlength="10"
                />
              </el-form-item>
            </div>
            <div class="form-row">
              <el-form-item label="年龄">
                <el-input
                  v-model="form.age"
                  placeholder="请输入年龄"
                  maxlength="10"
                />
              </el-form-item>
              <el-form-item label="职业">
                <el-input
                  v-model="form.profession"
                  placeholder="请输入职业"
                  maxlength="20"
                />
              </el-form-item>
            </div>
            <el-form-item label="特殊技能">
              <el-input
                v-model="form.skill"
                type="textarea"
                :rows="2"
                placeholder="描述角色的特殊技能..."
                show-word-limit
                maxlength="200"
              />
            </el-form-item>
            <el-form-item label="角色描述">
              <el-input
                v-model="form.desc"
                type="textarea"
                :rows="2"
                placeholder="描述角色的性格与背景..."
                show-word-limit
                maxlength="200"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div class="role_add_right">
        <div class="phone-mockup">
          <div class="phone-screen">
            <div class="phone-media">
              <el-image
                v-if="form.img"
                :src="form.img"
                alt="预览"
                fit="cover"
                style="width: 100%; height: 100%"
              />
              <div v-else class="media-placeholder">
                <el-icon><Plus /></el-icon>
                <span>暂无角色图片</span>
              </div>
            </div>

            <div class="phone-info">
              <div class="info-item highlight">
                <span class="label">姓名:</span>
                <span class="val">{{ form.name || "未命名" }}</span>
              </div>
              <div class="info-grid">
                <div class="info-item">
                  <span class="label">性别:</span>
                  <span class="val">{{ form.sex || "-" }}</span>
                </div>
                <div class="info-item">
                  <span class="label">年龄:</span>
                  <span class="val">{{ form.age || "-" }}</span>
                </div>
              </div>
              <div class="info-item">
                <span class="label">职业:</span>
                <span class="val">{{ form.profession || "-" }}</span>
              </div>
              <div class="info-item scrollable-text">
                <span class="label font-bold">技能:</span>
                <span class="val desc-text">{{
                  form.skill || "暂无描述"
                }}</span>
              </div>
              <div class="info-item scrollable-text">
                <span class="label font-bold">描述:</span>
                <span class="val desc-text">{{ form.desc || "暂无描述" }}</span>
              </div>
            </div>

            <div class="phone-action">
              <div class="continue-btn">继续</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="dialog-footer">
        <el-button @click="customDraggingVisible = false">取消</el-button>
        <el-button type="primary" @click="isUpdate ? updateRole() : addRole()">
          {{ isUpdate ? "确定修改" : "立即创建" }}
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script lang="ts">
// 脚本逻辑保持一致，无需做任何功能破坏性修改
import { Plus } from "@element-plus/icons-vue";
import { ElNotification } from "element-plus";

export default {
  name: "RoleScroll",
  components: {
    Plus,
  },
  data() {
    return {
      customDraggingVisible: false,
      fileList: [],
      isUpdate: false,
      form: {
        id: "",
        name: "",
        desc: "",
        img: "",
        sex: "",
        profession: "",
        age: "",
        skill: "",
      },
      roles: [],
    };
  },
  computed: {
    UpdateApi() {
      return process.env.VUE_APP_Update_API;
    },
  },
  methods: {
    init() {
      this.$store
        .dispatch("game/getRoles", { gameId: this.$route.params.id })
        .then((res: any) => {
          this.roles = res;
          this.customDraggingVisible = false;
          this.form = {
            id: "",
            name: "",
            desc: "",
            img: "",
            sex: "",
            profession: "",
            age: "",
            skill: "",
          };
          this.fileList = [];
        })
        .catch(() => {});
    },
    beforeAvatarUpload(file: File) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        ElNotification.warning({
          message: "请上传 png 或 jpg 格式的图片",
          offset: 100,
          duration: 3000,
        });
        return false;
      }
      if (!isLt2M) {
        ElNotification.warning({
          message: "图片大小不能超过 5MB",
          offset: 100,
          duration: 3000,
        });
        return false;
      }
      return true;
    },
    handleAvatarSuccess(response: any) {
      this.form.img = response.data.returnFileUrl;
    },
    addRole() {
      this.$store
        .dispatch("game/saveRole", {
          gameId: this.$route.params.id,
          roleDesc: this.form.desc,
          roleImg: this.form.img,
          roleName: this.form.name,
          roleAge: this.form.age,
          roleSex: this.form.sex,
          roleProfession: this.form.profession,
          roleSkill: this.form.skill,
        })
        .then((res: any) => {
          this.init();
        })
        .catch(() => {});
    },
    editRole(index: number) {
      const target = this.roles[index];
      this.form.desc = target.roleDesc;
      this.form.name = target.roleName;
      this.form.img = target.roleImg;
      this.form.id = target.roleId;
      this.form.age = target.roleAge;
      this.form.sex = target.roleSex;
      this.form.profession = target.roleProfession;
      this.form.skill = target.roleSkill;

      this.fileList = [];
      if (target.roleImg) {
        this.fileList.push({
          name: target.roleName + ".jpg",
          url: target.roleImg,
        });
      }
      this.customDraggingVisible = true;
    },
    deleteRole(index: number) {
      this.$store
        .dispatch("game/delRole", {
          ids: [this.roles[index].roleId],
        })
        .then((res: any) => {
          this.init();
        })
        .catch(() => {});
    },
    updateRole() {
      this.$store
        .dispatch("game/updRole", {
          roleId: this.form.id,
          gameId: this.$route.params.id,
          roleDesc: this.form.desc,
          roleImg: this.form.img,
          roleName: this.form.name,
          roleAge: this.form.age,
          roleSex: this.form.sex,
          roleProfession: this.form.profession,
          roleSkill: this.form.skill,
        })
        .then((res: any) => {
          this.init();
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped lang="less">
/* 全局滚动条优雅设计 */
::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(144, 147, 153, 0.3);
  border-radius: 4px;
  &:hover {
    background-color: rgba(144, 147, 153, 0.5);
  }
}
::-webkit-scrollbar-track {
  background-color: transparent;
}

/* 角色卡片滚动窗口区 */
.role-container {
  width: 100%;
  padding: 40px 0;
  overflow-x: auto;
  overflow-y: hidden;
  box-sizing: border-box;

  .role-list {
    display: flex;
    flex-wrap: nowrap;
    gap: 24px; // 卡片间距统一
    padding: 10px 20px;
    align-items: center;
  }
}

/* 角色卡片基础设计（完全统一高宽） */
.role-card {
  flex: 0 0 260px; // 禁止缩放，固定宽度
  width: 260px;
  height: 400px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  box-sizing: border-box;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12);
  }

  &-header {
    padding: 16px 16px 8px;
    text-align: center;
    .role-name {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
      color: #303133;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  &-media {
    flex: 1;
    overflow: hidden;
    background: #fafafa;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 16px;
    border-radius: 8px;

    .role-image {
      width: 100%;
      height: 100%;
      transition: transform 0.3s ease;
    }
  }

  &:hover .role-image {
    transform: scale(1.05);
  }

  &-footer {
    padding: 16px;
    display: flex;
    justify-content: center;
    gap: 16px;
    border-top: 1px solid #f9f9f9;
  }
}

/* 添加角色虚线触发器 */
.add-role-trigger {
  border: 2px dashed #c0c4cc;
  background: rgba(250, 250, 250, 0.7);
  box-shadow: none;
  cursor: pointer;
  justify-content: center;
  align-items: center;

  &:hover {
    border-color: #409eff;
    background: rgba(64, 158, 255, 0.02);
  }

  .add-icon-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;

    img {
      width: 48px;
      height: 48px;
      opacity: 0.6;
      transition: opacity 0.3s ease;
    }

    p {
      margin: 0;
      font-size: 16px;
      color: #606266;
      font-weight: 500;
    }
  }

  &:hover .add-icon-wrapper img {
    opacity: 1;
  }
}

/* 弹窗内容左右精细排版 */
.role_add {
  display: flex;
  gap: 30px;
  padding: 10px 0;
  box-sizing: border-box;

  &_left {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 24px;

    .upload-section {
      .section-title {
        display: block;
        margin-bottom: 8px;
        font-weight: 600;
        color: #303133;
      }

      .uploader-wrapper {
        display: flex;
        align-items: center;
        gap: 16px;

        .upload-tip {
          font-size: 13px;
          color: #909399;
          line-height: 1.6;
        }
      }
    }

    .form-section {
      .clean-form {
        .form-row {
          display: flex;
          gap: 16px;
          .el-form-item {
            flex: 1;
          }
        }

        .el-form-item {
          margin-bottom: 16px;

          :deep(.el-form-item__label) {
            font-weight: 600;
            color: #303133;
            padding-bottom: 6px;
          }
        }
      }
    }
  }

  /* 精美的 App 模拟手机预览区域 */
  &_right {
    flex: 0 0 340px;
    display: flex;
    justify-content: center;
    align-items: center;

    .phone-mockup {
      width: 300px;
      height: 600px;
      background: #000000;
      border-radius: 36px;
      padding: 12px; // 模拟黑边框
      box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
      box-sizing: border-box;

      .phone-screen {
        width: 100%;
        height: 100%;
        background: #ffffff;
        border-radius: 26px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        position: relative;

        .phone-media {
          width: 100%;
          height: 48%;
          background: #f5f7fa;
          display: flex;
          justify-content: center;
          align-items: center;

          .media-placeholder {
            display: flex;
            flex-direction: column;
            align-items: center;
            color: #c0c4cc;
            gap: 8px;
            font-size: 13px;
            .el-icon {
              font-size: 24px;
            }
          }
        }

        .phone-info {
          flex: 1;
          padding: 16px;
          display: flex;
          flex-direction: column;
          gap: 8px;
          overflow-y: auto;
          box-sizing: border-box;

          .info-item {
            display: flex;
            align-items: flex-start;
            font-size: 13px;
            line-height: 1.4;
            color: #606266;

            &.highlight {
              font-size: 16px;
              color: #303133;
              font-weight: bold;
              border-bottom: 1px solid #ebeef5;
              padding-bottom: 6px;
              margin-bottom: 4px;
            }

            .label {
              color: #909399;
              width: 65px;
              flex-shrink: 0;
              font-weight: 500;
            }

            .val {
              color: #303133;
              word-break: break-all;
            }

            &.scrollable-text {
              flex-direction: column;
              gap: 2px;
              .label {
                width: 100%;
                font-weight: bold;
                color: #555;
              }
              .desc-text {
                font-family: "PingFang SC", "Microsoft YaHei";
                background: #fafafa;
                border-radius: 4px;
                padding: 6px;
                width: 100%;
                box-sizing: border-box;
                min-height: 40px;
                max-height: 80px;
                overflow-y: auto;
              }
            }
          }

          .info-grid {
            display: flex;
            gap: 12px;
            .info-item {
              flex: 1;
            }
          }
        }

        .phone-action {
          padding: 12px 16px 20px;
          display: flex;
          justify-content: center;

          .continue-btn {
            width: 100%;
            height: 40px;
            background: #02a7e5;
            color: #ffffff;
            font-weight: 600;
            border-radius: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            cursor: pointer;
            box-shadow: 0 4px 8px rgba(2, 167, 229, 0.3);
            transition: all 0.2s ease;

            &:hover {
              background: #0294cc;
              box-shadow: 0 6px 12px rgba(2, 167, 229, 0.4);
            }
          }
        }
      }
    }
  }
}

/* 弹窗样式规范 */
:deep(.custom-dragging-style) {
  border-radius: 16px;
  .el-dialog__header {
    margin-right: 0;
    padding: 20px 24px;
    border-bottom: 1px solid #f0f0f0;
    .el-dialog__title {
      font-weight: 600;
      font-size: 18px;
    }
  }
  .el-dialog__body {
    padding: 24px;
  }
  .el-dialog__footer {
    padding: 16px 24px 20px;
    border-top: 1px solid #f0f0f0;
  }
}
</style>
